import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-04/lesson-16/task-02";

const task: Slide = {
  titleHtml:
    "Which of these curves representing the frequency behaviour of the sensitivity of an<br>omnidirectional condenser microphone corresponds to the case of a perfectly sealed<br>microphone capsule (without static pressure equalization hole)?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
